module.exports = __webpack_public_path__ + "static/media/OrderCancelled.7d7719d5.svg";